import React, { useEffect, useRef, useState } from "react";

const ImplementationSuccessSection = ({ stats }) => {
  const sectionRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="implementation-success-section py-5" ref={sectionRef}>
      <div className="container text-center">
        <h2 className="fw-bold mb-5 text-dark">Implementation Success</h2>
        <div className="row justify-content-center">
          {stats.map((item, i) => (
            <div className="col-6 col-sm-3 mb-4" key={i}>
              <div className={`success-circle ${isVisible ? "fade-in-up" : ""}`}>
                <h3 className="success-value">{item.value}</h3>
              </div>
              <h3 className="success-label">{item.label}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImplementationSuccessSection;
